module.exports = {"section":{"title":"Támogasd a Framasoftot","lead":"Mert a szabadságnak ára van…"}};